const PHONE = '561-445-3948';

const trustBadges = [
  { icon: 'ri-shield-check-line', label: '15+ Years Experience' },
  { icon: 'ri-verified-badge-line', label: 'Licensed & Insured' },
  { icon: 'ri-map-pin-2-line', label: 'Local South Florida' },
  { icon: 'ri-home-smile-line', label: '500+ Homes Cleaned' },
];

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/14b64ec8ff61db71fb8e7c521ab0bdcd.jpg"
          alt="Professional pressure washing service South Florida"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/65 to-slate-900/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 lg:pt-32 lg:pb-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-600/20 border border-teal-500/40 rounded-full px-4 py-1.5 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-fill text-teal-400 text-sm"></i>
            </div>
            <span className="text-teal-300 text-sm font-medium">Serving South Florida</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight mb-5">
            Your Home Should Look{' '}
            <span className="text-teal-400">Brand New Again</span>
            {' '}— Without Replacing Anything
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed mb-8 max-w-xl">
            Expert pressure cleaning, roof cleaning, driveways, screen patios &amp; gutter cleaning
            across South Florida. Free estimates. Fast scheduling. Guaranteed results.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <a
              href="#contact"
              className="bg-orange-500 hover:bg-orange-600 text-white font-black text-lg px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              Get a Free Estimate
            </a>
            <a
              href={`tel:${PHONE}`}
              className="bg-white/10 hover:bg-white/20 border-2 border-white/60 text-white font-black text-lg px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-orange-400 text-lg"></i>
              </div>
              Call {PHONE}
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-3">
            {trustBadges.map((badge) => (
              <div
                key={badge.label}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${badge.icon} text-teal-400 text-base`}></i>
                </div>
                <span className="text-white text-xs font-semibold whitespace-nowrap">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 z-10">
        <span className="text-white/50 text-xs font-medium">Scroll to see results</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
